import { render } from "./ValidateToken.html?vue&type=template&id=a2758402&external"
import script from "./ValidateToken.vue?vue&type=script&lang=js"
export * from "./ValidateToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__